'use strict';

require('./app.scss');

$$('.ll-app').each(function () {
	var $app = $$(this),
	    $window = $$(window),
	    $fixed = $app.find('.ll-app__fixed'),
	    offset = $fixed.offset().top,
	    $terms = $app.find('.ll-form-terms'),
	    $termsLink = $app.find('.ll-app__terms-link');

	$window.on('scroll', function (event) {
		var scroll = document.scrollingElement.scrollTop;

		if (scroll >= offset) $fixed.addClass('is-active');else $fixed.removeClass('is-active');
	});

	$termsLink.on('click', function (event) {
		$terms[0].open();
		event.preventDefault();
	});
});


//////////////////
// WEBPACK FOOTER
// ./src/app.js
// module id = 49
// module chunks = 0